import React, { useState, useEffect } from "react";
import CorporationDataService from "../../services/corporation.data.service";
import InsuredObjectDataService from "../../services/insured.object.data.service";
import { Form, Col, Row } from "react-bootstrap";
import SubmitButton from "../UI/Button/SubmitButton";
import { Formik } from "formik";
import * as Yup from "yup";
import { percentagePattern, pricePattern } from "../../patterns/patterns";
import styles from "./PAndIForm.module.scss";
import Select from "react-select";
import { chooseCustomSelectStyle } from "../../custom-style/custom-select";

const PAndIForm = (props) => {
  const data = props.editData;

  // The states for select fileds (corporation, ship)
  const [corporation, setCorporation] = useState([]);
  const [ship, setShip] = useState([]);

  // Function to get all corporations out of the database.
  const getAllCorporations = () => {
    CorporationDataService.getAll({ filter: "" })
      .then((response) => {
        let corporation = [];
        response.data.forEach((element) => {
          corporation.push({ value: element, label: element.name });
        });
        setCorporation(corporation);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Only call the getAllCorporations() function the first time this component
  // is rendered.
  useEffect(() => {
    getAllCorporations();
  }, []);

  // Function to get all ships out of the databse.
  const getAllShips = () => {
    InsuredObjectDataService.getAll({ filter: "" })
      .then((response) => {
        console.log(response.data);
        let ships = [];
        response.data.forEach((element) => {
          ships.push({ value: element, label: element.shipname });
        });
        setShip(ships);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Only call the getAllShips() function thr first time this component
  // is rendered.
  useEffect(() => {
    getAllShips();
  }, []);

  const PAndIObjectSchema = Yup.object().shape({
    fixed_premium: Yup.string()
      .required("Pflichtfeld")
      .matches(
        pricePattern,
        "Betrag mit Komma trennen und maximal 2 Nachkommastellen"
      ),
    fixed_premium_corp: Yup.string()
      .required("Pflichtfeld")
      .matches(
        pricePattern,
        "Betrag mit Komma trennen und maximal 2 Nachkommastellen"
      ),
    insurance_start: Yup.date().required("Pflichtfeld"),
    payment_method: Yup.string().nullable(),
    ship: Yup.object().required("Pflichtfeld").nullable(),
    corporation: Yup.object().required("Pflichtfeld").nullable(),
    tax: Yup.string()
      .matches(
        percentagePattern,
        "Mit Komma trennen maximal 2 Nachkommastellen"
      )
      .nullable(),
    brokerage: Yup.string()
      .matches(
        percentagePattern,
        "Mit Komma trennen maximal 2 Nachkommastellen"
      )
      .required("Pflichtfeld"),
    insurance_period_from: Yup.date().required("Pflichtfeld"),
    insurance_period_to: Yup.date().required("Pflichtfeld"),
    tax_free: Yup.boolean(),
  });

  return (
    <>
      <Formik
        validationSchema={PAndIObjectSchema}
        onSubmit={(values) => {
          const ship = values.ship;
          const corporation = values.corporation;
          console.log(values);
          props.onSubmit(values);
          values.ship = ship;
          values.corporation = corporation;
        }}
        validateOnBlur
        initialValues={{
          policy_number: data !== undefined ? data.policy_number : "",
          fixed_premium: data !== undefined ? data.fixed_premium : "",
          fixed_premium_corp: data !== undefined ? data.fixed_premium_corp : "",
          insurance_start: data !== undefined ? data.insurance_start : "",
          payment_method: data !== undefined ? data.payment_method : "",
          tax: data !== undefined && data.tax !== null ? data.tax : "",
          brokerage: data !== undefined ? data.brokerage : "",
          corporation:
            data !== undefined
              ? { value: data.corporation, label: data.corporation.name }
              : "",
          ship:
            data !== undefined
              ? { value: data.ship, label: data.ship.shipname }
              : "",
          termination:
            data !== undefined && data.termination !== null
              ? data.termination
              : "",
          insurance_period_from:
            data !== undefined ? data.insurance_period_from : "",
          insurance_period_to:
            data !== undefined ? data.insurance_period_to : "",
          tax_free: data !== undefined ? data.tax_free : "",
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          touched,
          errors,
          values,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridShip">
                <Form.Label>Schiff</Form.Label>
                <Select
                  isClearable
                  isSearchable
                  id="ship"
                  name="ship"
                  onChange={(selected) => {
                    console.log("Changed");
                    console.log(selected);
                    values.ship = selected;
                    setFieldValue("ship", selected);
                  }}
                  onBlur={handleBlur}
                  onMenuClose={() => setFieldTouched("ship", true, false)}
                  placeholder="Wähle ein Schiff..."
                  options={ship}
                  value={values.ship}
                  styles={chooseCustomSelectStyle(
                    errors.ship,
                    values.ship,
                    touched.ship
                  )}
                />
                {errors.ship && touched.ship ? (
                  <div className={styles["invalid-error"]}>{errors.ship}</div>
                ) : null}
              </Form.Group>

              <Form.Group as={Col} controlId="formGridCorporation">
                <Form.Label>Gesellschaft</Form.Label>
                <Select
                  isClearable
                  isSearchable
                  id="corporation"
                  name="corporation"
                  placeholder="Wähle Gesellschaft..."
                  onChange={(selected) => {
                    values.corporation = selected;
                    setFieldValue("corporation", selected);
                  }}
                  onBlur={handleBlur}
                  onMenuClose={() =>
                    setFieldTouched("corporation", true, false)
                  }
                  options={corporation}
                  value={values.corporation}
                  styles={chooseCustomSelectStyle(
                    errors.corporation,
                    values.corporation,
                    touched.corporation
                  )}
                />
                {errors.corporation && touched.corporation ? (
                  <div className={styles["invalid-error"]}>
                    {errors.corporation}
                  </div>
                ) : null}
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridFixedPremium">
                <Form.Label>Festprämie Kunde</Form.Label>
                <Form.Control
                  name="fixed_premium"
                  type="text"
                  placeholder="Festprämie"
                  value={values.fixed_premium}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() => setFieldTouched("fixed_premium", true, false)}
                  isValid={touched.fixed_premium && !errors.fixed_premium}
                  isInvalid={!!errors.fixed_premium && touched.fixed_premium}
                />
                {errors.fixed_premium && touched.fixed_premium ? (
                  <div className={styles["invalid-error"]}>
                    {errors.fixed_premium}
                  </div>
                ) : null}
              </Form.Group>
              <Form.Group as={Col} controlId="formGridFixedPremium">
                <Form.Label>Festprämie Gesell.</Form.Label>
                <Form.Control
                  name="fixed_premium_corp"
                  type="text"
                  placeholder="Festprämie G."
                  value={values.fixed_premium_corp}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() =>
                    setFieldTouched("fixed_premium_corp", true, false)
                  }
                  isValid={
                    touched.fixed_premium_corp && !errors.fixed_premium_corp
                  }
                  isInvalid={
                    !!errors.fixed_premium_corp && touched.fixed_premium_corp
                  }
                />
                {errors.fixed_premium_corp && touched.fixed_premium_corp ? (
                  <div className={styles["invalid-error"]}>
                    {errors.fixed_premium_corp}
                  </div>
                ) : null}
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridInsuranceStart">
                <Form.Label>Versicherungsbeginn</Form.Label>
                <Form.Control
                  name="insurance_start"
                  type="date"
                  placeholder="Versicherungsbeginn"
                  value={values.insurance_start}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() =>
                    setFieldTouched("insurance_start", true, false)
                  }
                  isValid={touched.insurance_start && !errors.insurance_start}
                  isInvalid={
                    !!errors.insurance_start && touched.insurance_start
                  }
                  disabled={props.isEditing}
                />
                {errors.insurance_start && touched.insurance_start ? (
                  <div className={styles["invalid-error"]}>
                    {errors.insurance_start}
                  </div>
                ) : null}
              </Form.Group>

              <Form.Group as={Col} controlId="formGridPaymentMethod">
                <Form.Label>Zahlungsmethode</Form.Label>
                <Form.Select
                  name="payment_method"
                  value={values.payment_method}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isValid={touched.payment_method && !errors.payment_method}
                  isInvalid={!!errors.payment_method && touched.payment_method}
                >
                  <option hidden>Methode wählen...</option>
                  <option></option>
                  <option>1</option>
                  <option>1/2</option>
                  <option>1/3</option>
                  <option>1/4</option>
                  <option>1/6</option>
                  <option>1/12</option>
                </Form.Select>
                {errors.payment_method && touched.payment_method ? (
                  <div className={styles["invalid-error"]}>
                    {errors.payment_method}
                  </div>
                ) : null}
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridInsurancePeriodFrom">
                <Form.Label>Versicherungszeitraum von</Form.Label>
                <Form.Control
                  name="insurance_period_from"
                  type="date"
                  placeholder="Versicherungszeitraum von"
                  value={values.insurance_period_from}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() =>
                    setFieldTouched("insurance_period_from", true, false)
                  }
                  isValid={
                    touched.insurance_period_from &&
                    !errors.insurance_period_from
                  }
                  isInvalid={
                    !!errors.insurance_period_from &&
                    touched.insurance_period_from
                  }
                />
                {errors.insurance_period_from &&
                touched.insurance_period_from ? (
                  <div className={styles["invalid-error"]}>
                    {errors.insurance_period_from}
                  </div>
                ) : null}
              </Form.Group>

              <Form.Group as={Col} controlId="formGridInsurancePeriodTo">
                <Form.Label>Versicherungszeitraum bis</Form.Label>
                <Form.Control
                  name="insurance_period_to"
                  type="date"
                  placeholder="Versicherungszeitraum bis"
                  value={values.insurance_period_to}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() =>
                    setFieldTouched("insurance_period_to", true, false)
                  }
                  isValid={
                    touched.insurance_period_to && !errors.insurance_period_to
                  }
                  isInvalid={
                    !!errors.insurance_period_to && touched.insurance_period_to
                  }
                />
                {errors.insurance_period_to && touched.insurance_period_to ? (
                  <div className={styles["invalid-error"]}>
                    {errors.insurance_period_to}
                  </div>
                ) : null}
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridTaxOne">
                <Form.Label>Steuer</Form.Label>
                <Form.Control
                  name="tax"
                  type="text"
                  placeholder="Steuer"
                  value={values.tax}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() => setFieldTouched("tax", true, false)}
                  isValid={touched.tax && !errors.tax}
                  isInvalid={!!errors.tax && touched.tax}
                />
                {errors.tax && touched.tax ? (
                  <div className={styles["invalid-error"]}>{errors.tax}</div>
                ) : null}
              </Form.Group>
              <Form.Group as={Col} controlId="formGridBrokerage">
                <Form.Label>Courtage</Form.Label>
                <Form.Control
                  name="brokerage"
                  type="text"
                  placeholder="Courtage"
                  value={values.brokerage}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onInput={() => setFieldTouched("brokerage", true, false)}
                  isValid={touched.brokerage && !errors.brokerage}
                  isInvalid={!!errors.brokerage && touched.brokerage}
                />
                {errors.brokerage && touched.brokerage ? (
                  <div className={styles["invalid-error"]}>
                    {errors.brokerage}
                  </div>
                ) : null}
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col}>
                <Form.Check
                  name="tax_free"
                  type="checkbox"
                  label="Versicherungssteuer frei"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isValid={touched.tax_free && !errors.tax_free}
                  isInvalid={!!errors.tax_free && touched.tax_free}
                  checked={values.tax_free}
                />
                {errors.tax_free && touched.tax_free ? (
                  <div className={styles["invalid-error"]}>
                    {errors.tax_free}
                  </div>
                ) : null}
              </Form.Group>
            </Row>
            <Row>
              {props.isEditing && (
                <Form.Group as={Col} controlId="formGridInsuranceStart">
                  <Form.Label>Kündigung zum</Form.Label>
                  <Form.Control
                    name="termination"
                    type="date"
                    placeholder="Kündigung zum"
                    value={values.termination}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={() => setFieldTouched("termination", true, false)}
                    isValid={touched.termination && !errors.termination}
                    isInvalid={!!errors.termination && touched.termination}
                  />
                  {errors.termination && touched.termination ? (
                    <div className={styles["invalid-error"]}>
                      {errors.termination}
                    </div>
                  ) : null}
                </Form.Group>
              )}
            </Row>
            <div className={styles.submitBtn}>
              <SubmitButton variant="primary" type="submit">
                {props.btnText}
              </SubmitButton>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PAndIForm;
